class ProductFinder extends HTMLElement {
  constructor() {
    super();
  }
  openStep(index) {
    const stepCount = this.querySelectorAll('[data-step]').length;
    const currentStep = this.steps[index - 1];
    if(!!currentStep) {
      if(index > 1){
        /* question view */
        const currentAnswers = currentStep.querySelectorAll(".answer-input:checked");
        const answersJson = Array.from(currentAnswers)?.map(answer => ({
          id: answer.dataset?.answerId,
          content: answer.dataset?.answerTitle
        }));
        const answer_event = new CustomEvent('productfinder:question_answered', {
          detail: {
            question: {
              id: currentStep.dataset?.questionId,
              content: currentStep.dataset?.questionTitle
            },
            answers: answersJson
          }
        });
        window.dispatchEvent(answer_event);
      } else {
        /* first interaction with finder */
        const start_event = new CustomEvent('productfinder:start');
        window.dispatchEvent(start_event);
      }
    }
    /* last step opened */
    if(index === (stepCount - 1)){
      const completed_event = new CustomEvent('productfinder:completed');
      window.dispatchEvent(completed_event);
    }
    this.steps.forEach((step) => {
      if (Number(step.dataset.step) <= index) {
        step.classList.add("active");
      } else {
        step.classList.remove("active");
      }
    });
  }
  submitProductFinder() {
    const form = this.querySelector('#product-finder-form');
    const form_data = new FormData(form);
    const question_steps = this.querySelectorAll('[data-question-id]');
    const properties = {
      'Routine': (form_data.get('contact[note][Routine]') ?? undefined),
      'Routinefinder Completion Date': (form_data.get('contact[note][Routinefinder Completion Date]') ?? undefined),
      'Routinefinder Results Basis': (form_data.get('contact[note][Routinefinder Results Basis]')?.split(',') ?? undefined),
      'Routinefinder Results Detailed': (form_data.get('contact[note][Routinefinder Results Detailed]')?.split(',') ?? undefined),
      'Routinefinder Teilnahme': (form_data.get('contact[note][Routinefinder Teilnahme]') === 'true'),
      'results_url': (form_data.get('contact[note][results_url]') ?? undefined),
    };
    question_steps.forEach(step => {
      const property_name = step.dataset.questionId;
      const property_value = form_data.get(`contact[note][${property_name}]`);
      properties[property_name] = property_value.includes(',') ? property_value.split(',') : property_value;
    });
    const attributes = {
      first_name: (form_data.get('contact[first_name]') ?? undefined),
      last_name: (form_data.get('contact[last_name]') ?? undefined),
      email: (form_data.get('contact[email]') ?? ''),
      phone_number: (form_data.get('contact[phone]') ?? undefined),
      properties: properties
    }
    const completed_event = new CustomEvent('productfinder:submit', {
      detail: {
        attributes: attributes
      }
    });
    window.dispatchEvent(completed_event);
    form.classList.add('submitted');
  }
  collectResult() {
    const result_buttons = this.querySelectorAll('.result-button');
    const result = {
      routine: {
        reinigen: [],
        klaren: [],
        wirken: [],
        schutzen: [],
        pflegen: []
      },
      crosssell: []
    }
    this.answer_inputs.forEach( input => {
      if(input.checked) {
        const answer_value = JSON.parse(input.value);
        result.routine.reinigen = result.routine.reinigen.concat(answer_value.routine.reinigen);
        result.routine.klaren = result.routine.klaren.concat(answer_value.routine.klaren);
        result.routine.wirken = result.routine.wirken.concat(answer_value.routine.wirken);
        result.routine.schutzen = result.routine.schutzen.concat(answer_value.routine.schutzen);
        result.routine.pflegen = result.routine.pflegen.concat(answer_value.routine.pflegen);
        result.crosssell = result.crosssell.concat(answer_value.crosssell);
      }
    });
    const result_page_url = this.getAttribute('result-page');
    const result_url = new URL(result_page_url, location.origin);
    const routine_basis = new Array();
    const routine_advanced = new Array();
    const first_available_reinigen = result.routine.reinigen.find(product => product.available);
    if(!!first_available_reinigen) {
      result_url.searchParams.set('reinigen', first_available_reinigen.handle);
      routine_advanced.push(first_available_reinigen.handle);
      routine_basis.push(first_available_reinigen.handle);
    }
    const first_available_klaren = result.routine.klaren.find(product => product.available);
    if(!!first_available_klaren) {
      result_url.searchParams.set('klaren', first_available_klaren.handle);
      routine_advanced.push(first_available_klaren.handle);
    }
    const available_wirken = result.routine.wirken.filter(product => product.available);
    if(available_wirken.length > 0) {
      const available_wirken_handles = [...new Set(available_wirken.map(product => product.handle))];
      const available_wirken_string = available_wirken_handles?.join(',');
      result_url.searchParams.set('wirken', available_wirken_string);
      routine_advanced.push(available_wirken_handles);
      routine_basis.push(available_wirken_handles);
    }
    const first_available_schutzen = result.routine.schutzen.find(product => product.available);
    if(!!first_available_schutzen) {
      result_url.searchParams.set('schutzen', first_available_schutzen.handle);
      routine_advanced.push(first_available_schutzen.handle);
    }
    const first_available_pflegen = result.routine.pflegen.find(product => product.available);
    if(!!first_available_pflegen) {
      result_url.searchParams.set('pflegen', first_available_pflegen.handle);
      routine_advanced.push(first_available_pflegen.handle);
      routine_basis.push(first_available_pflegen.handle);
    }
    const available_crosssell = result.crosssell.filter(product => product.available);
    if(available_crosssell.length > 0) {
      const available_crosssell_string = available_crosssell.map(product => product.handle)?.join(',');
      result_url.searchParams.set('crosssell', available_crosssell_string);
    }
    const answerTitles = [];
    document.querySelectorAll('[data-question-id]').forEach((question, index) => {
      let questionAnswerTitles = `${index}`;
      const checkedAnswers = question.querySelectorAll('[data-answer-title]:checked');
      checkedAnswers.forEach((checked_answer, index) => {
        if(index === 0) {
          questionAnswerTitles += '-:-';
        } else {
          questionAnswerTitles += '-|-';
        }
        questionAnswerTitles += checked_answer?.dataset?.answerTitle;
      });
      if(checkedAnswers.length > 0) {
        questionAnswerTitles = questionAnswerTitles.replace('&', '%26');
        answerTitles.push(questionAnswerTitles);
      }
    });
    result_url.searchParams.set('answers', answerTitles.join(','));
    result_buttons.forEach(result_button => result_button.setAttribute('href', result_url));
    //klaviyo form inputs
    const now = new Date();
    const form = this.querySelector('#product-finder-form');
    const question_steps = this.querySelectorAll('[data-question-id]');
    let answered_steps = 0;
    question_steps.forEach(step => {
      const property_name = step.dataset.questionId;
      const input = form.querySelector(`[name="contact[note][${property_name}]"]`);
      if(!!property_name && property_name !== '' && !!input){
        const checked_answers = step.querySelectorAll('.answer-input:checked');
        if(checked_answers.length > 0) {
          if(checked_answers.length > 1) {
            const value = Array.from(checked_answers)?.map(answer => answer.dataset?.answerTitle).join(',');
            input.value = value;
            answered_steps++;
          } else {
            const value = checked_answers[0]?.dataset?.answerTitle;
            input.value = value;
            answered_steps++;
          }
        }
      }
    });
    const completion_date_input = form.querySelector('[name="contact[note][Routinefinder Completion Date]"]');
    const routine_basis_input = form.querySelector('[name="contact[note][Routinefinder Results Basis]"]');
    const routine_advanced_input = form.querySelector('[name="contact[note][Routinefinder Results Detailed]"]');
    const routine_participation_input = form.querySelector('[name="contact[note][Routinefinder Teilnahme]"]');
    const routine_result_url_input = form.querySelector('[name="contact[note][results_url]"]');
    completion_date_input?.setAttribute('value', `${now.getDate()}.${now.getMonth() + 1}.${now.getFullYear()}`);
    routine_basis_input?.setAttribute('value', routine_basis.join(','));
    routine_advanced_input?.setAttribute('value', routine_advanced.join(','));
    routine_participation_input?.setAttribute('value', answered_steps === question_steps.length ? 'true' : 'false');
    routine_result_url_input?.setAttribute('value', result_url);
    form.classList.remove('submitted');
  }
  initQuestions() {
    const question_steps = this.querySelectorAll(".quiz-question.has-answers");
    question_steps.forEach(step => {
      const nextButton = step.querySelector("[data-next-step]");
      const resultButton = step.querySelector(".result-button");
      const answerInputs = step.querySelectorAll(".answer-input");
      const currentCount = step.querySelector("[data-current-count]");
      const maxCount = step.querySelector("[data-max-count]");
      const maxCountNumber = Number(maxCount.dataset.maxCount);
      let count = 0;
      answerInputs.forEach((input) => {
        if (input.checked) {
          count++;
        }
      });
      if (count > maxCountNumber) {
        currentCount.dataset.currentCount = maxCountNumber;
        return false;
      } else if (count < 1) {
        nextButton?.setAttribute("disabled", "");
        resultButton?.setAttribute("disabled", "");
        currentCount.dataset.currentCount = count;
      } else {
        nextButton?.removeAttribute("disabled");
        resultButton?.removeAttribute("disabled");
        currentCount.dataset.currentCount = count;
      }
    });
  }
  checkStepState(input, step) {
    const nextButton = step.querySelector("[data-next-step]");
    const resultButton = step.querySelector(".result-button");
    const answerInputs = step.querySelectorAll(".answer-input");
    const currentCount = step.querySelector("[data-current-count]");
    const maxCount = step.querySelector("[data-max-count]");
    const maxCountNumber = Number(maxCount.dataset.maxCount);
    let count = 0;
    answerInputs.forEach((input) => {
      if (input.checked) {
        count++;
      }
    });
    if (count > maxCountNumber) {
      input.checked = false;
      currentCount.dataset.currentCount = maxCountNumber;
      return false;
    } else if (count < 1) {
      nextButton?.setAttribute("disabled", "");
      resultButton?.setAttribute("disabled", "");
      currentCount.dataset.currentCount = count;
    } else {
      nextButton?.removeAttribute("disabled");
      resultButton?.removeAttribute("disabled");
      currentCount.dataset.currentCount = count;
    }
  }
  init() {
    this.answer_inputs = this.querySelectorAll(".answer-input");
    this.prev_buttons = this.querySelectorAll("[data-prev-step]");
    this.next_buttons = this.querySelectorAll("[data-next-step]");
    this.steps = this.querySelectorAll("[data-step]");
    this.last_step = this.querySelector("[data-final-step]");
    const openStep = this.openStep.bind(this);
    const checkStepState = this.checkStepState.bind(this);
    const collectResult = this.collectResult.bind(this);
    const initQuestions = this.initQuestions.bind(this);
    this.prev_buttons.forEach((prev_button) => {
      prev_button.addEventListener("click", (event) => {
        const prevStep = Number(prev_button.dataset.prevStep);
        if (prevStep === 0) {
          const popup = this.closest('product-finder-popup, product-finder-popup-ai');
          if (popup && typeof popup.close === 'function') {
            popup.close();
            return;
          }
        }
        openStep(prevStep);
      });
    });
    this.next_buttons.forEach((next_button) => {
      next_button.addEventListener("click", (event) => {
        openStep(Number(next_button.dataset.nextStep));
        initQuestions();
      });
    });
    this.answer_inputs.forEach((answer_input) => {
      const step = answer_input.closest("[data-step]");
      answer_input.addEventListener("input", (event) => {
        checkStepState(answer_input, step);
      });
      answer_input.addEventListener("input", collectResult);
    });
    const form = this.querySelector('#product-finder-form');
    const submitProductFinder = this.submitProductFinder.bind(this);
    form?.addEventListener('submit', event => {
      event.preventDefault();
      event.stopPropagation();
      submitProductFinder();
    }, true);
    const start_event = new CustomEvent('productfinder:init');
    window.dispatchEvent(start_event);
  }
  connectedCallback() {
    this.init();
  }
}
customElements.define("product-finder", ProductFinder);

class ProductFinderPopup extends HTMLElement {
  constructor() {
    super();
  }
  getFinder(url) {
    let that = this;
    fetch(url, {
      credentials: "same-origin",
      headers: { "X-Requested-With": "XMLHttpRequest" },
      method: "GET",
    })
    .then((response) => response.text())
    .then((data) => {
      const template = document.createElement("template");
      template.innerHTML = data.trim();
      const productfinder = template.content.querySelector('product-finder');
      if(!!productfinder) {
        that.insertAdjacentElement('afterbegin', productfinder);
        this.setAttribute('loaded', '');
      }
    })
    .catch(function (err) {
      console.error(err);
    });
  }
  open() {
    if(!this.hasAttribute('loaded')){
      this.getFinder(this.fetchURL);
    }
    window.theme.scroll.disable();
    this.setAttribute('open', '');
    document.body.classList.add('product-finder-open');
  }
  close() {
    this.removeAttribute('open');
    window.theme.scroll.enable();
    const close_event = new CustomEvent('productfinder:closed');
    window.dispatchEvent(close_event);
    document.body.classList.remove('product-finder-open');
  }
  connectedCallback() {
    const open = this.open.bind(this);
    const close = this.close.bind(this);
    this.fetchURL = this.getAttribute('product-finder-url');
    const closeButton = this.querySelector('.close-product-finder-popup');
    closeButton.addEventListener('click', close);
    const productFinderPath = this.fetchURL.split('?').shift();
    document.addEventListener('DOMContentLoaded', event => {
      const openButtons = document.querySelectorAll(`[href="${productFinderPath}"]`);
      openButtons.forEach(openButton => {
        openButton.addEventListener('click', event => {
          if(this.hasAttribute('product-finder-url-overwrite')){
            this.fetchURL = this.getAttribute('product-finder-url-overwrite');
          }
          event.preventDefault();
          open();
        });
      });
    });
  }
}
customElements.define("product-finder-popup", ProductFinderPopup);


class ProductFinderPopupAI extends HTMLElement {
  constructor() {
    super();
  }
  open() {
    window.theme.scroll.disable();
    this.setAttribute('open', '');
  }
  close() {
    this.removeAttribute('open');
    window.theme.scroll.enable();
  }
  connectedCallback() {
    const open = this.open.bind(this);
    const close = this.close.bind(this);
    this.fetchURL = this.getAttribute('product-finder-url');
    const closeButton = this.querySelectorAll('.close-product-finder-popup').forEach(closeButton =>
      closeButton.addEventListener('click', close)
    );
    /* const productFinderPath = this.fetchURL.split('?').shift();
    document.addEventListener('DOMContentLoaded', event => {
      const openButtons = document.querySelectorAll(`[href="${productFinderPath}"]`);
      openButtons.forEach(openButton => {
        openButton.addEventListener('click', event => {
         event.preventDefault();
         open();
        });
      });
    })*/
  }
}
customElements.define("product-finder-popup-ai", ProductFinderPopupAI);